export const actionTypes = {
  SET_MAINTENANCE_FLAGS: 'maintenance/SET_MAINTENANCE_FLAGS',
  CLEAR_MAINTENANCE_FLAGS: 'maintenance/CLEAR_MAINTENANCE_FLAGS',
} as const;
